module.exports = __webpack_public_path__ + "img/Payment_Live_inactive.5f0cef80.png";